/* ===========================================================
   PRASINOUS - Charm Engraving config
   Edit this file to add an engravable shape or to nudge the text
   box on one. No other file needs to change.
   =========================================================== */

/* -----------------------------------------------------------
   1) SHAPES

   One entry per physical shape, not per variant. The grid shows
   one card for the shape, and the panel asks for one side or both.

     handle  product handle, only used to read prices
     one     VARIANT id of the one side variant
     both    VARIANT id of the both sides variant, omit if the
             shape is only made single sided

   To add a shape: create the product with a Side option, then add
   four lines here. Nothing else.
   ----------------------------------------------------------- */
window.CP_ENGRAVE_SHAPES = {
  "round-disc": {
    label:  "Round Disc",
    handle: "two-side-disc-charm",
    one:    "54062642135347",
    both:   "54062642168115"
  },

  "medium-disc": {
    label:  "Medium Disc",
    handle: "medium-disc-charm-gold",
    one:    "51832401133875"
  }
};

/* Derived lookup, variant id -> shape. Do not edit by hand. */
window.CP_ENGRAVE_ITEMS = (function () {
  var out = {};
  var shapes = window.CP_ENGRAVE_SHAPES || {};
  Object.keys(shapes).forEach(function (key) {
    var s = shapes[key];
    if (s.one)  out[String(s.one)]  = { shape: key, sides: 1, handle: s.handle };
    if (s.both) out[String(s.both)] = { shape: key, sides: 2, handle: s.handle };
  });
  return out;
})();

/* -----------------------------------------------------------
   2) FONTS
   family must match a font actually loaded on the page. The panel
   snippet loads exactly these four. Keep in sync with Canva.
   ----------------------------------------------------------- */
window.CP_ENGRAVE_FONTS = [
  { key: "classic", label: "Classic", family: "'Montserrat', sans-serif",    weight: 600 },
  { key: "script",  label: "Script",  family: "'Dancing Script', cursive",   weight: 700 },
  { key: "times",   label: "Times",   family: "'Lora', serif",               weight: 500 },
  { key: "elegant", label: "Elegant", family: "'Cormorant Garamond', serif", weight: 600 }
];

/* -----------------------------------------------------------
   3) GEOMETRY - where the text sits on the charm image
   All values are PERCENTAGES of the charm PNG box.

     cx, cy      centre of the text block
     w           width of the safe text area
     lineGap     line spacing, multiple of the font size
     lineScale   font size as a fraction of w, per line count
                 [1 line, 2 lines, 3 lines]
     color       etching colour
     maxChars    hard input limit per line
     upright     true keeps the text horizontal even when the charm
                 is rotated on a bracelet

   Resolution order: byShape -> bySize -> default. Partial overrides
   are fine, write only what changes.

   Add ?cp_tune=1 to the product URL for live sliders and a ready to
   paste block. Every shape needs this done once.
   ----------------------------------------------------------- */
window.CP_ENGRAVE_GEOMETRY = {
  default: {
    cx: 50,
    cy: 58,
    w: 46,
    lineGap: 1.18,
    lineScale: [0.30, 0.24, 0.19],
    color: "#4a3f35",
    maxChars: 14,
    upright: true
  },

  bySize: {
    xsmall:    {},
    small:     {},
    medium:    {},
    large:     {},
    morelarge: {}
  },

  byShape: {
    "round-disc":  {},
    "medium-disc": {}
  }
};

/* -----------------------------------------------------------
   4) COPY - customer facing strings
   ----------------------------------------------------------- */
window.CP_ENGRAVE_COPY = {
  typeText:      "Text",
  typePhoto:     "Photo",
  oneSide:       "One side",
  bothSides:     "Both sides",
  frontTab:      "Front",
  backTab:       "Back",
  fontLabel:     "Font",
  sidesLabel:    "Etching",
  photoHeadline: "Send us your photo",
  photoBody:     "Place your order, then email your photo to prasinous@prasinous.com with your order number. We turn it into a laser etching and confirm the artwork with you before we make it.",
  photoTile:     "PHOTO",
  charNote:      "Up to 14 characters per line. Past 10 characters the text gets smaller to fit.",
  finalSale:     "Personalized pieces are made to order and cannot be returned or exchanged.",
  emptyWarning:  "Add at least one line of text to your personalized charm, or switch to Photo.",
  backOptional:  "Leaving the back blank is fine. We will email you if we need anything."
};
